import _ from '@/utils/lodash-optimized'
import React from 'react'
import { connect } from 'react-redux'

import { Nucc } from '../../../../../../lib/Codes/index.js'
import http from '../../../../../../lib/http'
import { mapOrganization, unmapOrganization } from '../../../../../../lib/Proxy/organizations.js'
import * as Card from '../../../../../shared/card'
import CrudTable from '../../../../../shared/CrudTable/index.jsx'
import ConfirmationDeleteDialog from '../../../../../shared/DeleteDialog/ConfirmationDeleteDialog.jsx'
import { Checkbox } from '../../../../../shared/NarusMaterial'
import FormattedPhone from '../../../../../shared/Phone/FormattedPhone.jsx'

import OrganizationForm from './form'

export const mkSpec = patientId => ({
  type: 'organizationCareTeamMember',
  form: OrganizationForm,
  urls: {
    get: () => `/patients/${patientId}/organizationsCareTeam`,
    create: () => `/patients/${patientId}/organizationsCareTeam`,
    update: entry =>
      `/patients/${patientId}/organizationsCareTeam/${entry.id}`,
    delete: entry =>
      `/patients/${patientId}/organizationsCareTeam/${entry.id}`
  },
  mapFns: {
    toForm: unmapOrganization,
    toFhir: entry => mapOrganization(patientId, entry)
  },
  table: [
    {
      title: 'Name',
        displayFn: x => x?.name
    },
    {
      title: 'Type',
      displayFn: x => {
        if (!x.type || x.type.length !== 10) {
          return null /* 'Unknown / Unspecified'; */
        }

        return _.filter(Nucc, n => n.code === x.type)[0]?.label || ''
      }
    },
    {
      title: 'Phone',
        displayFn: x => <FormattedPhone number={x?.phone}/>
    },
    {
      title: '',
      displayFn: () => <span>&nbsp;</span>
    },
    {
      title: 'Email',
        displayFn: x => x?.email
    },
    {
      title: '',
      displayFn: () => <span>&nbsp;</span>
    },
    {
      title: 'Preferred',
        displayFn: x => x?.preferred
    }
  ]
})

class OrganizationsGrid extends React.Component {
  UNSAFE_componentWillMount () {
    this.setState({ noPrefLoading: true })
    http
      .getRequest(
        `/patients/${this.props.patientId}/organizationsCareTeam/noPref`
      )
      .then(r => {
        this.setState({
          noPref: r.noPref,
          noPrefLoading: false
        })
      })
  }

  handleNoPreferred (val) {
    this.setState({ noPrefLoading: true })
    http
      .putRequest(
        `/patients/${this.props.patientId}/organizationsCareTeam/noPref`,
        {
          noPref: val
        }
      )
      .then(() => {
        this.setState({
          noPref: val,
          noPrefLoading: false
        })
      })
  }

  render () {
    const patientId = this.props.params
      ? this.props.params.id
      : this.props.patientId
    const spec = mkSpec(patientId)

    return (
      <Card.Card expandable>
        <Card.Header>
          <h2>
            Organizations
          </h2>
          {this.props.anyPreferred}
          <Checkbox
            label='Patient does not have any preferred organization'
            value={this.state && this.state.noPref}
            disabled={this.props.anyPreferred || this.state.noPrefLoading}
            onChange={val => {
              this.handleNoPreferred(val)
            }}
          />

        </Card.Header>
        <Card.ExpandableWrapper
          style={{ padding: '0 1rem 1rem 1rem' }}
        >
          <CrudTable
            urlFns={spec.urls}
            entryType={spec.type}
            entrySet={patientId}
            tableDefinition={spec.table}
            mapFns={spec.mapFns}
            form={spec.form}
            deleteDialog={ConfirmationDeleteDialog}
            additionalFormProps={{ noPref: this.state.noPref }}
            labelButton='Organization'
            labelNoEntries='Organizations'
            callbackFn={this.props.onSubmit}
            updateKey={this.props.formKey}
          />
        </Card.ExpandableWrapper>
      </Card.Card>
    )
  }
}

const mapStateToProps = redux => ({
  practitionerId: redux.auth.profile.sub,
  patientId: redux.globalVars.params.id,
  anyPreferred: (
      redux?.crudTable?.organizationCareTeamMembers?.entries ?? []
  ).some(p => p?.preferred === 'yes')
})

export default connect(mapStateToProps)(OrganizationsGrid)
